import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance70 = () => {
  let winners = ["312", "428"];

  return <IndividualTable matchType={"4"} gender="M" event="70" subTitle="Puta" data={sampleData} topRankCount="2" winners={winners} />;
};
export default Distance70;
